import { collection, addDoc, getDocs, query, where, orderBy, Timestamp } from 'firebase/firestore';
import { db } from '../config/firebase';
import { InvoiceItem } from '../config/types';

export interface LoadEntry extends Omit<InvoiceItem, 'id'> {
  id?: string;
  status: 'pending' | 'completed' | 'cancelled';
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

const COLLECTION_NAME = 'invoices';

export const addLoadEntry = async (loadData: InvoiceItem): Promise<string> => {
  try {
    const docRef = await addDoc(collection(db, COLLECTION_NAME), {
      ...loadData,
      status: 'pending',
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now()
    });
    return docRef.id;
  } catch (error) {
    console.error('Error adding load entry:', error);
    throw error;
  }
};

export const getPendingLoads = async (): Promise<LoadEntry[]> => {
  try {
    const q = query(
      collection(db, COLLECTION_NAME),
      where('status', '==', 'pending'),
      orderBy('createdAt', 'desc')
    );
    
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as LoadEntry[];
  } catch (error) {
    console.error('Error getting pending loads:', error);
    throw error;
  }
};

export const getAllLoads = async (): Promise<LoadEntry[]> => {
  try {
    const q = query(
      collection(db, COLLECTION_NAME),
      orderBy('createdAt', 'desc')
    );
    
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as LoadEntry[];
  } catch (error) {
    console.error('Error getting all loads:', error);
    throw error;
  }
}; 